import client from "../index.js";
import { GET_DOMAINS } from "./query.js";
import { UPDATE_DOMAIN } from "./mutation.js";
import { createReferenceMemo } from "../referenceMemo.js";

// Domains are reference data; memoize per-input and invalidate on the
// domain mutations below.
const domainsMemo = createReferenceMemo();

export const apiGetAllDomains = () =>
  domainsMemo.run("all", () =>
    client
      .query({
        query: GET_DOMAINS,
        variables: { input: {} },
        fetchPolicy: "no-cache",
      })
      .then((res) => res.data?.domains?.domains || [])
  );

export const apiGetDomainByName = (name) =>
  domainsMemo.run(`name:${name}`, () =>
    client
      .query({
        query: GET_DOMAINS,
        variables: { input: { name } },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        const domains = res.data?.domains?.domains || [];
        return domains.length > 0 ? domains[0] : null;
      })
  );

export const apiUpdateDomainCompanyKnowledge = (domainId, companyKnowledgeBase) => {
  return client
    .mutate({
      mutation: UPDATE_DOMAIN,
      variables: { input: { id: domainId, companyKnowledgeBase } },
    })
    .then((res) => {
      domainsMemo.clear();
      return res.data?.updateDomain?.domain;
    });
};

export const apiUpdateDomainMetadata = (input) => {
  return client
    .mutate({
      mutation: UPDATE_DOMAIN,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      domainsMemo.clear();
      return res.data?.updateDomain?.domain || null;
    });
};

export const apiUpdateDomainAvatar = (domainId, avatar) => {
  return client
    .mutate({
      mutation: UPDATE_DOMAIN,
      variables: { input: { id: domainId, avatar } },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      domainsMemo.clear();
      return res.data?.updateDomain?.domain || null;
    });
};
